import { useState } from 'react';
import { VisitaApi } from '../consts/types';
import { useMemo } from 'react';

const useVisitsSelection = (visibleVisits: VisitaApi[] = []) => {
    const [selectedVisitsIds, setSelectedVisits] = useState<number[]>([]);

    const isChecked = (id: number): boolean => {
        return selectedVisitsIds.includes(id);
    };

    const handleAllCheckPress = (allVisits: VisitaApi[]) => {
        const visitsIds = allVisits.map((visit) => visit.id);
        const hasAllVisibleChecked = visitsIds.every((id) => selectedVisitsIds.includes(id));

        if (hasAllVisibleChecked) {
            setSelectedVisits((current) => current.filter((id) => !visitsIds.includes(id)));
            return;
        }

        setSelectedVisits((current) => Array.from(new Set([...current, ...visitsIds])));
    };

    const handleCheckPress = (item: VisitaApi) => {
        if (isChecked(item.id)) {
            setSelectedVisits(selectedVisitsIds.filter((id) => id !== item.id));
        } else {
            setSelectedVisits([...selectedVisitsIds, item.id]);
        }
    };

    const isAllChecked = useMemo(() => {
        if (!visibleVisits.length) {
            return false;
        }

        return visibleVisits.every((visit) => selectedVisitsIds.includes(visit.id));
    }, [selectedVisitsIds, visibleVisits]);

    const clearVisitsSelection = () => {
        setSelectedVisits([]);
    };

    return {
        selectedVisitsIds,
        setSelectedVisits,
        isChecked,
        isAllChecked,
        handleAllCheckPress,
        handleCheckPress,
        clearVisitsSelection
    };
};

export default useVisitsSelection;
